import firebase from 'firebase/compat/app';

import STORE_CONSTANTS from '../constants';
import agentKbRootDoc from './agentKbRootDoc';

const converter = {
  toFirestore(item: AgentKb.Version): firebase.firestore.DocumentData {
    return { ...item };
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions,
  ): AgentKb.Version {
    return {
      ...(snapshot.data(options) as AgentKb.Version),
      id: snapshot.id,
    };
  },
};

// Published version manifests: agentKb/main/versions/{versionId}. One doc per
// GCS version folder; immutable, and the thing a pin points at.
const getAgentKbVersionsRef = ({
  scope,
  accountId,
  db,
}: {
  scope: AgentKb.ScopeName;
  accountId?: string;
  db?: firebase.firestore.Firestore;
}) =>
  agentKbRootDoc({ scope, accountId, db })
    .collection(STORE_CONSTANTS.AGENT_KB_VERSIONS_COLLECTION)
    .withConverter(converter);

export default getAgentKbVersionsRef;
